import QuarantineComponent from ".";

export const quarantineRoutes = [
  {
    path: "/quarantine",
    element: <QuarantineComponent />,
  },
];
